/**
 * JavaScript 运行时读取主题色的唯一入口。
 * 这里只保存 CSS 变量名称，真实颜色值统一维护在 design-tokens.scss。
 */
const THEME_COLOR_TOKENS = Object.freeze({
  primary: '--ui-color-primary',
  primaryHover: '--ui-color-primary-hover',
  primaryActive: '--ui-color-primary-active',
  warning: '--ui-color-warning',
  warningHover: '--ui-color-warning-hover',
  warningActive: '--ui-color-warning-active',
  danger: '--ui-color-danger',
  dangerHover: '--ui-color-danger-hover',
  dangerActive: '--ui-color-danger-active',
  dangerStrong: '--ui-color-danger-strong',
  accent: '--ui-color-accent',
  black: '--ui-color-black',
  particleCore: '--ui-particle-core',
  particleCoreSoft: '--ui-particle-core-soft',
  particleWarm: '--ui-particle-warm',
  particleGlow: '--ui-particle-glow',
  backgroundCanvas: '--ui-bg-canvas',
  backgroundPanel: '--ui-bg-panel',
  backgroundElevated: '--ui-bg-panel-elevated',
  appTextPrimary: '--ui-text-primary',
  appTextRegular: '--ui-text-regular',
  appTextSecondary: '--ui-text-secondary',
  appBorder: '--ui-border-color',
  appBorderSubtle: '--ui-border-color-subtle',
  textSecondary: '--ui-light-text-secondary',
  textRegular: '--ui-light-text-regular',
  textPlaceholder: '--ui-light-text-placeholder',
  textInverse: '--ui-text-inverse',
  eventFlightController: '--ui-event-flight-controller',
  eventEsp: '--ui-event-esp',
  eventTerminal: '--ui-event-terminal',
  eventSystem: '--ui-event-system',
  routePalette1: '--ui-route-palette-1',
  routePalette2: '--ui-route-palette-2',
  routePalette3: '--ui-route-palette-3',
  routePalette4: '--ui-route-palette-4',
  routePalette5: '--ui-route-palette-5',
  routePalette6: '--ui-route-palette-6',
  routePalette7: '--ui-route-palette-7',
  routePalette8: '--ui-route-palette-8',
  routePalette9: '--ui-route-palette-9',
  routePalette10: '--ui-route-palette-10',
  routePalette11: '--ui-route-palette-11',
  routePalette12: '--ui-route-palette-12',
  routePalette13: '--ui-route-palette-13',
  routePalette14: '--ui-route-palette-14',
  routePalette15: '--ui-route-palette-15',
  routePalette16: '--ui-route-palette-16',
  mapDrawDanger: '--ui-map-draw-danger',
  mapDrawWarning: '--ui-map-draw-warning',
  mapDrawHandle: '--ui-map-draw-handle',
  chartPrimary: '--ui-chart-primary',
  chartSecondary: '--ui-chart-secondary',
  chartTertiary: '--ui-chart-tertiary',
  chartMuted: '--ui-chart-muted',
  tooltipBackground: '--ui-tooltip-background',
  homeButtonDefaultBackground: '--ui-home-button-default-background',
  homeButtonDefaultText: '--ui-home-button-default-text',
  homeButtonFoodBackground: '--ui-home-button-food-background',
  homeButtonGoodsBackground: '--ui-home-button-goods-background',
  homeButtonGoodsText: '--ui-home-button-goods-text',
  homeButtonLegacyCoral: '--ui-home-button-legacy-coral',
  homeButtonLegacyCream: '--ui-home-button-legacy-cream',
  homeButtonLegacySand: '--ui-home-button-legacy-sand',
  weatherLeafGreen: '--ui-weather-leaf-green',
  weatherLeafOlive: '--ui-weather-leaf-olive',
  weatherLeafGold: '--ui-weather-leaf-gold',
  weatherLeafBrown: '--ui-weather-leaf-brown',
  weatherRainSoft: '--ui-weather-rain-soft',
  weatherRain: '--ui-weather-rain',
  weatherHailShadow: '--ui-weather-hail-shadow',
  weatherHail: '--ui-weather-hail',
  weatherSnow: '--ui-weather-snow',
  weatherWind: '--ui-weather-wind',
  weatherLeafOutline: '--ui-weather-leaf-outline'
})

export function getThemeColor (name) {
  const token = THEME_COLOR_TOKENS[name]
  if (!token || typeof window === 'undefined') return ''
  return window.getComputedStyle(document.documentElement).getPropertyValue(token).trim()
}

export function getThemeColorWithAlpha (name, alpha) {
  const color = getThemeColor(name)
  const normalizedAlpha = Math.max(0, Math.min(1, Number(alpha)))
  const hex = color.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i)
  if (hex) {
    const value = hex[1].length === 3
      ? hex[1].split('').map(char => char + char).join('')
      : hex[1]
    const channels = value.match(/.{2}/g).map(channel => parseInt(channel, 16))
    return `rgba(${channels.join(', ')}, ${normalizedAlpha})`
  }

  const rgb = color.match(/^rgba?\((\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i)
  return rgb ? `rgba(${rgb[1]}, ${rgb[2]}, ${rgb[3]}, ${normalizedAlpha})` : color
}

export function getEventThemeColor (sourceType = 'esp') {
  const tokenMap = {
    fc: 'eventFlightController',
    esp: 'eventEsp',
    terminal: 'eventTerminal',
    system: 'eventSystem'
  }
  return getThemeColor(tokenMap[sourceType] || tokenMap.esp)
}
